exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-copy/equipment-copy.component.css
// module id = ../../../../../src/app/views/home/equipment/equipment-copy/equipment-copy.component.css
// module chunks = main